import React from 'react';
import {AutoField} from '../../fields';
import Section from 'components/forms/Section';
import {H6} from 'components/TypographyShortcuts';
import fields from 'components/forms/noaatoss/fields';
import {useFieldData} from 'components/forms/hooks';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import {RequiresSignatureAbortButton} from 'components/forms/sections';

const Signature = ({...props}) => {
    const {initialValues, schema} = bootstrapOldForm('Signature', fields);
    const [signed, setSigned] = useFieldData('document_signed');
    const [officialLetterhead, setOfficialLetterhead] = useFieldData(
        'official_letterhead'
    );

    const showWarning =
        signed === false ||
        signed === 'false' ||
        officialLetterhead === false ||
        officialLetterhead === 'false';

    const updateOfficialLetterhead = event => {
        setOfficialLetterhead(event.target.value === 'true');
    };
    const updateSigned = event => {
        setSigned(event.target.value === 'true');
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <H6>Signature</H6>
            <AutoField field={fields['ssl_type']} name='ssl_type' />
            <AutoField
                field={fields['official_letterhead']}
                name='official_letterhead'
                onChange={updateOfficialLetterhead}
            />
            <AutoField
                field={fields['document_signed']}
                name='document_signed'
                onChange={updateSigned}
            />
            <AutoField
                field={fields['date_document_signed']}
                name='date_document_signed'
            />
            {showWarning && <RequiresSignatureAbortButton />}
            {props.children}
        </Section>
    );
};

export default Signature;
